import { Change } from 'sync-engine';

type SideEffect = (change: Change) => void;

const Helpers = {
    matchComponentInstance: <T extends object>(path: string, regex: RegExp) => {
        const combined = new RegExp(/^componentInstances\.(?<id>.*)\./.source + regex.source);
        const match = path.match(combined);

        if (!match || !match.groups) {
            return null;
        }

        const { id } = match.groups;

        return {
            ...(match.groups as T),
            id,
        };
    },

    matchConnection: <T extends object>(path: string, regex: RegExp) => {
        const combined = new RegExp(/^connections\.(?<id>.*)\./.source + regex.source);
        const match = path.match(combined);

        if (!match || !match.groups) {
            return null;
        }

        const { id } = match.groups;

        return {
            ...(match.groups as T),
            id,
        };
    },

    removePrefix: (path: string) => {
        if (path.startsWith('connections.') || path.startsWith('componentInstances.')) {
            return path.split('.').splice(2).join('.');
        }

        return path;
    },
};

export { Helpers };
export type { SideEffect };
